<template>
  <div class="birefringence-stress-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Δn = C(σ1 - σ2) | 应力双折射$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <defs>
             <!-- Beautiful Stress Pattern (Gradient Mesh simulation) -->
             <radialGradient id="stressGrad1" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stop-color="#ff4757" />
                <stop offset="40%" stop-color="#ffd700" />
                <stop offset="70%" stop-color="#2ed573" />
                <stop offset="100%" stop-color="#1e90ff" />
             </radialGradient>
          </defs>

          <!-- Polarizer 1 (Fixed) -->
          <rect x="20" y="60" width="10" height="120" fill="rgba(80,80,80,0.6)" />
          <line x1="25" y1="80" x2="25" y2="160" stroke="#fff" stroke-width="1" />

          <!-- The Plastic Model -->
          <g transform="translate(100, 70)">
             <rect width="200" height="100" fill="#333" stroke="#888" rx="8" />
             <!-- Stress fringes -->
             <circle v-for="n in Number(stress)" :key="n" 
                     :cx="100 + (n%5-2)*30" :cy="50 + (n%3-1)*20" 
                     :r="20 + n*5" fill="url(#stressGrad1)" :opacity="0.1 + stress/20" />
          </g>

          <!-- The Force Applicator -->
          <line x1="200" y1="20" x2="200" y2="70" stroke="#ffd700" stroke-width="4" marker-end="url(#arrow-head)" />
          <text x="185" y="15" fill="#ffd700" font-size="8">施加压力</text>

          <!-- Polarizer 2 (Analyzer) -->
          <rect x="350" y="60" width="10" height="120" fill="rgba(80,80,80,0.6)" 
                :transform="`rotate(${analyzerAngle}, 355, 120)`" />

          <defs>
            <marker id="arrow-head" markerWidth="10" markerHeight="10" refX="5" refY="5" orient="auto">
               <path d="M0,0 L10,5 L0,10 Z" fill="#ffd700" />
            </marker>
          </defs>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>应力水平: {{ stress }} MPa</label>
              <div class="value" style="color: #ff4757">结果: {{ analyzerAngle % 90 == 0 ? '消光位' : '干涉色产生' }}</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节压力</label>
             <el-slider v-model="stress" :min="0" :max="10" size="mini"></el-slider>
          </div>
          <div class="row items-center mt-2">
             <label>检偏器角度</label>
             <el-slider v-model="analyzerAngle" :min="0" :max="90" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>光弹性效应是指某些透明材料（如环氧树脂或玻璃）在受到机械应力时，会表现出**临时双折射**的特性。此时材料内部分子的排列变得具有各向异性，导致光在其中不同方向的传播速度不同。在两片正交偏振片之间观察，这些相位差会转化为绚烂的彩色条纹（干涉色）。工程师利用这种方法来直观地观察复杂机械结构的应力分布，找出最脆弱的设计薄弱点。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BirefringenceStressViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      stress: 5,
      analyzerAngle: 90
    }
  }
}
</script>

<style scoped lang="scss">
.birefringence-stress-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 71, 87, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
